import { fileGenerateAccessUrlMutationAtom } from '../_graphql/mutations/fileGenerateAccessUrlMutation';

// 🟠🟠🟠 ACTION -> GENERATE ACCESS URL
export const $generateAccessUrl = fileGenerateAccessUrlMutationAtom({
  onSuccess: () => {
    // No refetch needed for generating access URLs
  },
});
